import { ConverterCtor } from "./Converter";
import IBooleanToSimple from "./IBooleanToSimple";
import IEnumToSimple from "./IEnumToSimple";
import INumericToNumber from "./INumericToNumber";
import INumericToSimple from "./INumericToSimple";
import IStatusToBrush from "./IStatusToBrush";
import ObjectToString from "./ObjectToString";

const converters: {
  [key: string]: ConverterCtor;
} = {
  "converters:IBooleanToSimple": IBooleanToSimple,
  "converters:IEnumToSimple": IEnumToSimple,
  "converters:INumericToNumber": INumericToNumber,
  "converters:INumericToSimple": INumericToSimple,
  "converters:ObjectToString": ObjectToString,
  "kitPx:IStatusToBrush": IStatusToBrush,
};

// eslint-disable-next-line import/prefer-default-export
export function findConverter(type: string): ConverterCtor | undefined {
  return converters[type];
}
